import { gql } from '@apollo/client';

export const HEALTH_CHECKUP_INSTITUTION = gql`
  query healthCheckupInstitution($id: Int!) {
    healthCheckupInstitution(id: $id) {
      id
      healthCheckupInstitutionId
      name
      location
    }
  }
`;
